module.exports = function(h, row) {
    var tags = row.tags;

    if (tags.length < 1) {
        return <i class="text-muted">No tag assigned</i>;
    }

    if (tags.length == 1) {
        return tags[0].name;
    }

    if (tags.length == 2) {
        return `${tags[0].name} and ${tags[1].name}`;
    }

    if (tags.length == 3) {
        return `${tags[0].name}, ${tags[1].name} and ${tags[2].name}`;
    }

    if (tags.length > 3) {
        const total = tags.length - 2;
        return `${tags[0].name}, ${tags[1].name} and +${total} tags`;
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/columns/tags.jsx